var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { removeHashRevokeUserEmail } from '@/shared/utils/helpers';
let AccountManagementNavbarHeaderContainer = class AccountManagementNavbarHeaderContainer extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
    }
    get ownerName() {
        return this.account.owner.name || 'Sem Proprietário';
    }
    get clickCreditType() {
        if (this.account.credits.unlimited_click) {
            return 'Ilimitado';
        }
        return this.account.credits.click;
    }
    get accountPreferenceEmail() {
        return (removeHashRevokeUserEmail(this.account.owner.email) ||
            'E-mail da conta não configurado');
    }
    hasEmail() {
        return this.accountPreferenceEmail.includes('@');
    }
    // eslint-disable-next-line getter-return
    get headerStyle() {
        if (this.$q.screen.sm)
            return { 'max-width': '180px' };
        if (this.$q.screen.md)
            return { 'max-width': '200px' };
        if (this.$q.screen.lg)
            return { 'max-width': '220px' };
        if (this.$q.screen.xl)
            return { 'max-width': '225px' };
    }
    get account() {
        return this.$store.getters['admin/get_selected_account_info'];
    }
};
AccountManagementNavbarHeaderContainer = __decorate([
    Component
], AccountManagementNavbarHeaderContainer);
export default AccountManagementNavbarHeaderContainer;
